export const settings = {
  cancel: {
    body: "If you choose to cancel, your current subscription will be active until the end of your billing period. You will not be charged again after your current billing period ends.",
    cta: "Cancel Membership",
    doCancel: "Cancel Plan",
    dontCancel: "Don't Cancel",
    title: "Cancel your plan?",
  },
  canceled: {
    description: "You've cancelled your {{plan}} membership.",
    timing: "Changes will go into effect on {{date}}.",
  },
  changingFrom: {
    plus: "Click <Strong>Save</Strong> to upgrade your Membership to $t(settings.premium) ($129.00/month). You will be charged an additional prorated amount at the beginning of your next billing cycle.",
    premium:
      "Click <Strong>Save</Strong> to downgrade your membership to $t(settings.plus) ($49.00/month). You will receive a credit for the prorated amount which will be reflected at the beginning of your next billing cycle.",
  },
  currentPlan: {
    plus: "You are currently enrolled in $t(common.plans.plus) at $49.00/month.",
    premium:
      "You are currently enrolled in $t(common.plans.premium) at $129.00/month.",
  },
  membership: "Membership",
  membershipNotification: "Membership Notification",
  nextBillingDate: "Next billing date:",
  partner: {
    description:
      "Your current plan is {{partnerName}} x Conceive for 3 months until {{endDate}}.",
    extensionCta: "Extend today",
    upcoming:
      "On {{date}} your membership will lapse unless you extend for Premium or Plus.",
    upcomingExtended:
      "On {{date}} you will switch to $t(common.plans.{{plan}}) billed {{interval}}.",
  },
  pauseConfirmation: {
    heading: "You're officially on a break!",
    gotItCta: "Got it",
    pauseDetails:
      "Your account pause will begin on <br/><Emphasis>{{startedAt}}</Emphasis> and end on <Emphasis>{{endedAt}}</Emphasis>.",
    additionalDetails:
      "You can reactivate any time by going to your account settings.",
  },
  resumeConfirmation: {
    heading: "Welcome back to Conceive!",
    dismissCta: "Got it",
    details:
      "We’re so glad to have you! You now have access to all your Conceive membership benefits—including your care team and dashboard. We’re here if you need help getting back into the swing of things!",
  },
  manageBilling: {
    label: "Billing: ",
    "1-month": "Monthly",
    "3-months": "Every 3 Months",
    "6-months": "Every 6 Months",
    "12-months": "Annually",
    changeCta: "Manage Billing",
  },
  managePlan: {
    label: "Plan: ",
    plus: "$t(common.plans.plus)",
    premium: "$t(common.plans.premium)",
    changeCta: "Manage Plan",
  },
  pauseDetails: {
    description:
      "Your account pause will begin on <strong>{{startedAt}}</strong> and end on <strong>{{endedAt}}</strong>.",
    reactivateDescription: "You can reactivate at any time.",
    reactivateCta: "Reactivate your membership",
  },
  pausedModal: {
    heading: "You're currently on a break!",
    description:
      "Ready to come back? You can reactivate your membership any time to gain access to your Conceive benefits—including your care team and dashboard.",
    cta: "Reactivate now",
  },
  planDescription: {
    plus: "Details: 24/7 text and digital support from the Conceive Care Team.",
    premium:
      "Details: 24/7 text, phone, and video chat with the Conceive Care Team—plus community support.",
  },
  planDetails: "What else is included in my plan?",
  reactivateCta: "Reactivate",
  resume: {
    body: "Your account will not longer be paused and you can continue using your membership benefits.<br/><br/>Please note that you can only do this once and won’t be able to pause your subscription again.",
    cta: "Reactivate Membership",
    doResume: "Reactivate my account",
    dontResume: "Nevermind",
    title: "Reactivate your membership?",
  },
  title: "Settings",
};
